import React from 'react';
import { TSM_THEME } from '../settings';

const TsmThemeContext = React.createContext(TSM_THEME);

export default TsmThemeContext;
